// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder--z0Xno","text":"text--_AvAO","indicator":"indicator--WUU_E"};